module.exports = __webpack_public_path__ + "04_very_short_black.0d9c9df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_very_short_black.png
// module id = JHrx
// module chunks = 0